<h2 mat-dialog-title>{{ 'AI_ASSISTANT.SETTINGS.CUSTOM_KNOWLEDGE.ADD_KNOWLEDGE' | translate }}</h2>
<mat-dialog-content>
  @if (creatingTextKnowledge()) {
    <ng-container *ngTemplateOutlet="addTextKnowledge"></ng-container>
  } @else if (creatingWebKnowledge()) {
    <ng-container *ngTemplateOutlet="addWebKnowledge"></ng-container>
  } @else {
    <ng-container *ngTemplateOutlet="knowledgeList"></ng-container>
  }
</mat-dialog-content>
<mat-dialog-actions>
  @if (creatingTextKnowledge() || creatingWebKnowledge()) {
    <button mat-stroked-button (click)="cancelCreate()">Cancel</button>
    <button mat-flat-button color="primary" (click)="createKnowledge()">Create</button>
  } @else {
    <button mat-stroked-button mat-dialog-close>{{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}</button>
  }
</mat-dialog-actions>

<ng-template #knowledgeList>
  <div class="knowledge-list">
    <mat-card class="add-button capability-card" [matMenuTriggerFor]="knowledgeTypeMenu">
      <mat-card-content>
        <mat-icon svgIcon="ai-knowledge-icon" class="knowledge-icon" matListItemIcon></mat-icon>
        <div class="new-knowledge-title">{{ 'AI_ASSISTANT.SETTINGS.CUSTOM_KNOWLEDGE.NEW_KNOWLEDGE' | translate }}</div>
      </mat-card-content>
    </mat-card>
    <mat-menu #knowledgeTypeMenu="matMenu">
      <button mat-menu-item (click)="createTextKnowledge()">
        <div class="add-ks-option">
          <span>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.KNOWLEDGE_TYPES.TEXT.TITLE' | translate }}</span>
          <span class="option-description">{{
            'AI_ASSISTANT.KNOWLEDGE_ACCESS.KNOWLEDGE_TYPES.TEXT.DESCRIPTION' | translate
          }}</span>
        </div>
      </button>
      <button mat-menu-item (click)="createWebKnowledge()">
        <div class="add-ks-option">
          <span>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.KNOWLEDGE_TYPES.WEBSITE.TITLE' | translate }}</span>
          <span class="option-description">{{
            'AI_ASSISTANT.KNOWLEDGE_ACCESS.KNOWLEDGE_TYPES.WEBSITE.DESCRIPTION' | translate
          }}</span>
        </div>
      </button>
    </mat-menu>
    @for (ks of knowledgeSources; track ks.id) {
      <mat-card (click)="chooseKnowledgeSource(ks)" class="clickable-card">
        <mat-card-content>
          <mat-icon svgIcon="ai-knowledge-icon" class="knowledge-icon" matListItemIcon></mat-icon>
          <div class="knowledge-name">
            {{ ks.name }}
          </div>
          <div class="knowledge-description">
            {{ getKnowledgePreview(ks) }}
          </div>
        </mat-card-content>
      </mat-card>
    }
  </div>
</ng-template>

<ng-template #addTextKnowledge>
  <ng-container [formGroup]="newKnowledgeForm()">
    <glxy-form-field>
      <glxy-label>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.NAME' | translate }}</glxy-label>
      <input type="text" matInput formControlName="name" />
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.CONTENT' | translate }}</glxy-label>
      <glxy-label-hint>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.CONTENT_HINT' | translate }}</glxy-label-hint>
      <textarea
        matInput
        formControlName="content"
        cdkTextareaAutosize
        cdkAutosizeMinRows="15"
        cdkAutosizeMaxRows="60"
      ></textarea>
    </glxy-form-field>
  </ng-container>
</ng-template>

<ng-template #addWebKnowledge>
  <ng-container [formGroup]="newKnowledgeForm()">
    <glxy-form-field>
      <glxy-label>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.NAME' | translate }}</glxy-label>
      <input type="text" matInput formControlName="name" />
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.URL' | translate }}</glxy-label>
      <input type="text" matInput formControlName="url" />
    </glxy-form-field>
    <glxy-form-field>
      <glxy-label>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.MODE' | translate }}</glxy-label>
      <mat-select formControlName="crawlMode">
        @for (mode of modeOptions; track mode) {
          <mat-option [value]="mode.value">{{ mode.label | translate }}</mat-option>
        }
      </mat-select>
    </glxy-form-field>
  </ng-container>
</ng-template>
